export default "__VITE_ASSET__58048a24__"